import { Panel } from '@ibinder/common-frontend';
import styled, { css } from 'styled-components';

export const RightPanel = styled(Panel)`
  background: ${(p) => p.theme.colors.discrete5};
  display: ${(p) => (p.isOpen ? 'block' : 'none')};
  height: auto;
  margin-top: 1rem;
  margin-left: 1px;
  border-radius: 4px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  ${({ noSticky }) =>
    !noSticky &&
    css`
      position: sticky;
      right: 0.5rem;
      top: 5.5rem;
    `}
  @media (max-width: ${(props) => props.theme.devices.md}px) {
    width: 100%;
  }
`;
